export const getNotificationMessages = (state) => state.notification.notificationList;
export const getUnreadMessages = (state) => state.notification.unreadNotifications;
